export const ADVERTISEMENT = 'containerItems.advertisement';
